const getDataFile = ({ district }) => {
	const data = require(`./${district}.json`);
	return data;
};

const getPinsDataFile = ({ district }) => {
	const data = require(`./pins/${district}.json`);
	return data;
};

export { getDataFile, getPinsDataFile };
